import Icon from "@material-ui/icons/Person";
import ApproveCcaStudentRenewalWithSchedule from "./ApproveCcaStudentRenewalWithSchedule";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "approveCcaStudentRenewalWithSchedules",
  create: ApproveCcaStudentRenewalWithSchedule,
  icon: Icon,
};
